module.exports = __webpack_public_path__ + "static/media/coffee-latte-mb-fr.60047856.jpg";